import { Group, Paper, Stack } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './CaseloadTabPanelLayout.module.css';

/** Gap between filter/search row and table card — matches Transfer Portal tab rhythm. */
export const CASELOAD_TAB_FILTER_TABLE_GAP = 'md' as const;

export interface CaseloadTabPanelLayoutProps {
  /** Search bar and filter controls rendered above the table card. These stretch to fill the row. */
  filters?: ReactNode;
  /** Right-aligned actions on the filter row (e.g. Request Referrals). Keeps its natural width. */
  filterActions?: ReactNode;
  /** Optional alerts between the filter row and table card. */
  alerts?: ReactNode;
  children: ReactNode;
}

/**
 * Shared caseload tab shell: optional filter row, consistent spacing, bordered table card.
 * Transfer Portal tab is the visual reference for spacing and card styling.
 */
export function CaseloadTabPanelLayout({
  filters,
  filterActions,
  alerts,
  children,
}: CaseloadTabPanelLayoutProps): JSX.Element {
  const showFilterRow = filters != null || filterActions != null;

  return (
    <Stack gap={CASELOAD_TAB_FILTER_TABLE_GAP}>
      {showFilterRow ? (
        <Group justify="space-between" align="center" wrap="wrap" gap="md">
          {filters ? (
            <Group gap="md" wrap="wrap" className={classes.filterRow}>
              {filters}
            </Group>
          ) : null}
          {filterActions}
        </Group>
      ) : null}
      {alerts}
      <Paper p="lg" withBorder>
        {children}
      </Paper>
    </Stack>
  );
}
